<template>
  <div class="ficheVIsioVente">
    <!-- catalogue produits -->
    <wz-catalogue-produits
      @pushproduct="msg => $emit('pushproduct', msg)"
    >
    </wz-catalogue-produits>

  </div>
</template>

<script>
export default {
  props: {
    datasVisiteur: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {},
  created () {},
  mounted () {},
  beforeDestroy () {},
  methods: {}
}

</script>

<style>
.ficheVIsioVente  {
  width: calc(100% - 26px);
  margin-left: 6px;
}
.ficheVIsioVente .v-text-field__solo {
  width: calc(100% - 26px);
} 
.ficheVIsioVente .v-text-field__slot {
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzFichePushProduit.vue